export default __webpack_public_path__ + "static/media/leader-board-desktop-bg.4e5b0e42.png";